"use client";

import { H4 } from "@/components-shared/headers";
import Image from "next/image";
import ReplyComment from "./ReplyComment";
import { User } from "@/components-shared/icons";

import greenFeedback from "@/public/images/feedback-star-green.svg";
import { useTranslations } from "next-intl";
type CommentProps = {
  name: string;
  date: string;
  rate: string;
  hostname?: string;
  reply?: string;
  children: string;
};

const Comment = ({
  date,
  name,
  rate,
  children,
  hostname,
  reply,
}: CommentProps) => {
  const t = useTranslations();

  return (
    <div>
      <div className="space-y-4 p-5">
        <header className="flex items-center gap-6">
          <div className="border rounded-full p-3">
            <User className="size-8" />
          </div>
          <div>
            <div className="flex items-center gap-5">
              <H4>{name}</H4>
              <span className="flex text-green-main gap-1 items-center">
                <Image
                  src={greenFeedback.src}
                  alt={t("comment.star")}
                  width={24}
                  height={24}
                />
                <span className="text-xl font-semibold">{rate}</span>
              </span>
            </div>
            <span className="text-sm font-light text-gray-dark">{date}</span>
          </div>
        </header>
        <p className="whitespace-pre-line">{children}</p>
      </div>
      {reply && <ReplyComment hostname={hostname as string} reply={reply} />}
    </div>
  );
};

export default Comment;
